import React, { useState } from 'react'
import {
  Modal, Row, Col, Input, Alert,
} from 'antd'

import __ from '../../languages/parser'

import { GASSIEN_COLOR } from '../../static/colors'

const ModalOpenComposition = ({
  visible, hide, getComposition, setComposition,
}) => {
  const [id, setId] = useState('')
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)

  const handleOk = () => {
    setConfirmLoading(true)
    setErrorMessage(false)

    getComposition(id, (err, res) => {
      if (err || !res.schema) {
        setConfirmLoading(false)
        setErrorMessage(__('This composition doesn\'t exist'))
      } else {
        setComposition(res.schema)
        setConfirmLoading(false)
        hide()
      }
    })
  }

  return (
    <Modal
      title={__('Open composition')}
      visible={visible}
      confirmLoading={confirmLoading}
      onOk={handleOk}
      onCancel={hide}
      okButtonProps={{ disabled: id.length !== 6 }}
      zIndex={99999}
    >
      <p>{__('Please enter your composition number')}</p>
      <Row>
        <Col offset={4} span={16}>
          <Input
            placeholder="-CODE-"
            value={id}
            onChange={(e) => {
              setErrorMessage(false)
              setId((e.target.value.slice(0, 6).toUpperCase()))
            }}
            style={{
              color: GASSIEN_COLOR,
              fontSize: '1.4em',
              lineHeight: '2em',
              letterSpacing: '0.4em',
              textAlign: 'center',
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ textAlign: 'center', color: 'red', marginTop: '1em' }}>
          {errorMessage
            ? <Alert message={errorMessage} type="warning" showIcon />
            : null}
        </Col>
      </Row>
    </Modal>
  )
}

export default ModalOpenComposition
